import { render } from "./InstallmentsPlan.vue?vue&type=template&id=923b4642"
import script from "./InstallmentsPlan.vue?vue&type=script&lang=js"
export * from "./InstallmentsPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__